// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__hNzf9","mainContent":"LandingPage_mainContent__Lcr+y"};